export default "__VITE_ASSET__DwS6$UtW__"